window.searchLinksLoadMore = function searchLinksLoadMore() {

    var load_more = $('.js_searchLoadMore a'),
        search_link_wrap = $('.searchTaglineWrap'),
        search_link = $('.searchTaglineWrap li:not(.js_searchLoadMore)'),
        search_link_length = search_link.length,
        slice = 4;

    if (search_link_wrap.length) {

        // hide load more unless required
        if (search_link.length < slice) {
            load_more.hide();
        }

        // hide them
        search_link.hide();

        // show unsliced links
        search_link.slice(0, slice).show();

        // load rest on click
        load_more.on('click', function (e) {
            e.preventDefault();

            $('.searchTaglineWrap li:hidden').slice(0, search_link_length).show().css('display', 'inline-block');
            search_link_wrap.toggleClass('open');

            if (search_link_wrap.hasClass('open')) {
                load_more.text('View Less -');
            } else {
                search_link.slice(slice, search_link_length).hide();
                load_more.text('View More +');
            }

        });
    }
}

$(document).ready(function () {
    'use strict';

    searchLinksLoadMore();
})